/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  getAiReplySettings(conversationID) {
    return axios.get(`${this.url}/${conversationID}/ai_reply_settings`);
  }

  updateAiReplySettings(conversationID, data) {
    return axios.patch(`${this.url}/${conversationID}/ai_reply_settings`, data);
  }
}

export default new ConversationApi();
